import constants from "../constants/constants";

export function formatStr(str) {
  // More careful replacement to preserve OData query structure
  const result = str
    .replaceAll(" and ", "(S)and(S)")
    .replaceAll(" or ", "(S)or(S)")
    .replaceAll(" eq ", "(S)eq(S)")
    .replaceAll(" ge ", "(S)ge(S)")
    .replaceAll(" le ", "(S)le(S)")
    .replaceAll(" lt ", "(S)lt(S)")
    .replaceAll(" gt ", "(S)gt(S)")
    .replaceAll("contains(", "contains(")
    .replaceAll("', '", "',(S)'")
    .replaceAll("')", "')")
    .replaceAll("(", "(")
    .replaceAll(")", ")")
    .replaceAll("&", "(A)")
    .replaceAll("?", "(Q)")
    .replaceAll(" ", "(S)");

  return result;
}


export function formatImages(media) {
  return media.reduce((acc, img) => {
    if (!acc[img.ResourceRecordKey]) {
      acc[img.ResourceRecordKey] = [];
    }
    acc[img.ResourceRecordKey].push(img);
    return acc;
  }, {});
}